import { useSnapshot } from "valtio";
import { uiState } from "./data";
import { AnimatePresence, motion } from "framer-motion";
import { googleSheet } from "./utils/getSheet";
import Img from "./utils/Img";
import { useEffect, useRef } from "react";
import { windowSizeState } from "./utils/windowSize";
import { isMobile, isTablet } from "react-device-detect";

export default function Home({ event }) {
  const {
    prevMousePosition,
    isEnterHoverArrow3,
    isCopyrightHover,
    isCopyrightOpen,
    isEnterHoverStart,
  } = useSnapshot(uiState[event]);
  const { isLandscape } = useSnapshot(windowSizeState);

  const data = googleSheet["title"][0];
  const ref = useRef(null);

  const scrollToBottom = () => {
    console.log("scrollToBottom");
    console.log(ref);
    if (ref.current) {
      setTimeout(() => {
        window.scrollTo({
          top: ref.current.clientHeight,
          behavior: "smooth",
        });
      }, 0);
    }
  };

  const goVr = () => {
    let currentUrl = window.location.href;
    var newUrl = currentUrl.replace("/start/start.html", "/vr/v0.html");
    window.location.href = newUrl;
  };

  // 橫向平板
  if (isLandscape && isTablet) {
    return (
      <>
        <AnimatePresence>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="w-full h-[200dvh] absolute top-0 flex border-b-[15px] border-[#c89e45]">
            <div className="absolute top-0 left-0 border-t-[20px] border-[#007175] w-[calc(36%+3px)] h-[50%]"></div>
            <div className="absolute top-0 right-0 border-t-[20px] border-[#c89e45] w-[calc(63%+9px)] h-[50%]"></div>

            <Img
              src={"../media/index_bg.png"}
              className="w-full h-full object-cover"
              alt="background"
            />
          </motion.div>
          <motion.div
            key="logo"
            ref={ref}
            className="absolute top-0 w-full h-[200dvh] overflow-hidden">
            <div className="absolute top-0 w-full h-dvh">
              <div className="absolute top-0 left-0 w-[37%] h-full flex flex-col justify-center items-center">
                <Img src="../media/logo.png" className="h-[70%]" alt="logo" />
                <Img
                  src={
                    isEnterHoverArrow3
                      ? "../media/arrow3H.png"
                      : "../media/arrow3.png"
                  }
                  className="mt-10 cursor-pointer"
                  alt="arrow3 icon"
                  onClick={scrollToBottom}
                  onMouseEnter={() =>
                    (uiState[event].isEnterHoverArrow3 = true)
                  }
                  onMouseLeave={() =>
                    (uiState[event].isEnterHoverArrow3 = false)
                  }
                />
                <p className="mt-5 font-black">下滑繼續閱讀</p>
              </div>

              {/* into */}

              <motion.div
                key="into"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}>
                <div
                  className={`absolute top-[100%] right-0 w-[63.5%] h-full flex flex-col justify-center items-center pt-[7.5%]`}>
                  <div className="flex flex-col items-center w-full h-full">
                    <div className="flex justify-center items-center text-2xl w-[70%] mb-5 text-[#c89e45]">
                      <Img
                        src="../media/title1.png"
                        className="flex max-w-[7%]"
                        alt="arrow3 icon"
                      />
                      <div className="w-[40px] box-border h-[40px] bg-[#1a7f81] rounded-full  flex text-center align-middle items-center justify-center -mr-1">
                        <p className="-translate-y-[1px]">展</p>
                      </div>
                      <div className="w-[40px] box-border h-[40px] bg-[#1a7f81] rounded-full  flex text-center align-middle items-center justify-center -mr-1">
                        <p className="-translate-y-[1px]">場</p>
                      </div>
                      <div className="w-[40px] box-border h-[40px] bg-[#1a7f81] rounded-full flex text-center align-middle items-center justify-center -mr-1">
                        <p className="-translate-y-[1px]">簡</p>
                      </div>
                      <div className="w-[40px] box-border h-[40px] bg-[#1a7f81] rounded-full flex text-center align-middle items-center justify-center">
                        <p className="-translate-y-[1px]">介</p>
                      </div>
                      <Img
                        src="../media/title1.png"
                        className="flex max-w-[7%] transform -scale-x-100"
                        alt="arrow3 icon"
                      />
                    </div>
                    <p className="w-[43%] h-[50%] overflow-auto text-xl mb-[5%] ">
                      {data.zh_content}
                    </p>
                    <Img
                      src={
                        isEnterHoverStart
                          ? "../media/inH.png"
                          : "../media/in.png"
                      }
                      className="flex w-[20%] mb-20 cursor-pointer"
                      alt="arrow3 icon"
                      onClick={goVr}
                      onMouseEnter={() =>
                        (uiState[event].isEnterHoverStart = true)
                      }
                      onMouseLeave={() =>
                        (uiState[event].isEnterHoverStart = false)
                      }
                    />
                  </div>
                </div>
              </motion.div>

              {/* copyright  */}

              <motion.div
                key="copyRight"
                initial={{ opacity: 0, y: "97%" }}
                animate={{ opacity: 1 }}
                // animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                onAnimationComplete={() =>
                  (uiState[event].isLastAnimationOpen = false)
                }
                className={`flex justify-center absolute top-[92%] right-0 w-[66%] h-full box-border`}>
                <div className="w-full h-full absolute left-0 top-[2%] z-50">
                  <div className="flex items-center justify-center space-x-10">
                    <Img
                      src="../media/thxname1.png"
                      className="object-contain"
                    />
                    <Img src="../media/thxname2.png" />
                  </div>
                </div>
                {/* </div> */}
              </motion.div>
            </div>
          </motion.div>
        </AnimatePresence>
      </>
    );
  }
  // mobile
  if (isMobile) {
    return (
      <>
        <AnimatePresence>
          <motion.div
            ref={ref}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
            className="relative flex flex-col">
            <Img
              src={"../media/index_mb.png"}
              className="object-cover -translate-y-[20px]"
              alt="background"
            />
            <div className="w-full h-dvh absolute top-0 flex justify-center items-center ">
              <div className="absolute top-0 left-0 w-full h-full flex flex-col pt-20 items-center">
                <Img
                  src="../media/logo.png"
                  className="w-[120px] pad:w-[200px] pad:pt-20 pad:mb-5"
                  alt="logo"
                />

                <Img
                  src={"../media/arrow3.png"}
                  className="mt-3 w-[30px] h-[30px] ph:w-[40px] ph:h-[40px]"
                  alt="arrow3 icon"
                  onClick={scrollToBottom}
                />
                <p className="mt-3 font-black">下滑繼續閱讀</p>
              </div>
            </div>

            {/* copy right */}
            <div
              className={`w-full h-dvh absolute bottom-0 overflow-y-hidden bg-[#F5F2E8]`}>
              <div className="flex flex-col items-center w-full h-full translate-y-[10%] relative bg-[#F5F2E8]">
                <div className="flex justify-center items-center text-[#c89e45] text-lg ph:text-xl w-[70%] mb-5 font-semibold absolute top-0">
                  <Img
                    src="../media/title1.png"
                    className="flex w-[40px] ph:w-[60px]"
                    alt="arrow3 icon"
                  />
                  <div className="w-[30px] h-[30px] bg-[#1a7f81] rounded-full flex items-center justify-center -mr-1">
                    <p className="translate-x-[1px]">展</p>
                  </div>
                  <div className="w-[30px] h-[30px] bg-[#1a7f81] rounded-full flex items-center justify-center -mr-1">
                    <p className="translate-x-[1px]">場</p>
                  </div>
                  <div className="w-[30px] h-[30px] bg-[#1a7f81] rounded-full flex items-center justify-center -mr-1">
                    <p className="translate-x-[1px]">簡</p>
                  </div>
                  <div className="w-[30px] h-[30px] bg-[#1a7f81] rounded-full flex items-center justify-center">
                    <p className="translate-x-[1px]">介</p>
                  </div>
                  <Img
                    src="../media/title1.png"
                    className="flex w-[40px] ph:w-[60px] transform -scale-x-100"
                    alt="arrow3 icon"
                  />
                </div>
                <p className="w-[70%] h-[50%] overflow-auto text-sm ph:text-lg mb-3 translate-y-[75px]">
                  {data.zh_content}
                </p>
                {!isCopyrightOpen && (
                  <Img
                    src={"../media/in.png"}
                    className="flex h-[30px] ph:h-[50px] mb-10 translate-y-[90px]"
                    alt="arrow3 icon"
                    onClick={goVr}
                  />
                )}

                {/* copy right animate */}
                <motion.div
                  initial={{ y: "87%" }}
                  // animate={{ y: isCopyrightOpen ? "77%" : "87%" }}
                  transition={{ duration: 0.5 }}
                  className=" w-full h-full flex justify-center items-center absolute bottom-16 z-[50] text-3xl overflow-x-hidden ">
                  <div className="absolute top-[2%] flex justify-center">
                    <Img
                      src="../media/thxname1.png"
                      className="object-contain w-[45%] mr-5"
                    />
                    <Img
                      src="../media/thxname2.png"
                      className="object-contain w-[45%]"
                    />
                    <div className="w-full h-full bg-[#c89e45] absolute bottom-0 translate-y-[calc(110%)]"></div>
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </>
    );
  }
  // pc
  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="w-full h-[200dvh] absolute top-0 flex border-b-[15px] border-[#c89e45]">
          <div className="absolute top-0 left-0 border-t-[15px] border-[#007175] w-[37%] h-[50%]"></div>
          <div className="absolute top-0 right-0 border-t-[15px] border-[#c89e45] w-[63.2%] h-[50%]"></div>

          <Img
            src={"../media/index_bg.png"}
            className="w-full h-full object-cover"
            alt="background"
          />
        </motion.div>
        <motion.div
          key="logo"
          ref={ref}
          className="absolute top-0 w-full h-[200dvh] overflow-hidden">
          <div className="absolute top-0 w-full h-dvh">
            <div className="absolute top-0 left-0 w-[37%] h-full flex flex-col justify-center items-center">
              <Img src="../media/logo.png" className="h-[70%]" alt="logo" />
              <Img
                src={
                  isEnterHoverArrow3
                    ? "../media/arrow3H.png"
                    : "../media/arrow3.png"
                }
                className="mt-10 cursor-pointer"
                alt="arrow3 icon"
                onClick={scrollToBottom}
                onMouseEnter={() => (uiState[event].isEnterHoverArrow3 = true)}
                onMouseLeave={() => (uiState[event].isEnterHoverArrow3 = false)}
              />
              <p className="mt-5 font-black">下滑繼續閱讀</p>
            </div>

            {/* into */}

            <motion.div
              key="into"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}>
              <div
                className={`absolute top-[100%] right-0 w-[63.5%] h-full flex flex-col justify-center items-center pt-[7.5%]`}>
                <div className="flex flex-col items-center w-full h-full">
                  <div className="flex justify-center items-center text-2xl w-[70%] mb-5 text-[#c89e45]">
                    <Img
                      src="../media/title1.png"
                      className="flex max-w-[7%]"
                      alt="arrow3 icon"
                    />
                    <div className="w-[40px] box-border h-[40px] bg-[#1a7f81] rounded-full  flex text-center align-middle items-center justify-center -mr-1">
                      <p className="-translate-y-[1px]">展</p>
                    </div>
                    <div className="w-[40px] box-border h-[40px] bg-[#1a7f81] rounded-full  flex text-center align-middle items-center justify-center -mr-1">
                      <p className="-translate-y-[1px]">場</p>
                    </div>
                    <div className="w-[40px] box-border h-[40px] bg-[#1a7f81] rounded-full flex text-center align-middle items-center justify-center -mr-1">
                      <p className="-translate-y-[1px]">簡</p>
                    </div>
                    <div className="w-[40px] box-border h-[40px] bg-[#1a7f81] rounded-full flex text-center align-middle items-center justify-center">
                      <p className="-translate-y-[1px]">介</p>
                    </div>
                    <Img
                      src="../media/title1.png"
                      className="flex max-w-[7%] transform -scale-x-100"
                      alt="arrow3 icon"
                    />
                  </div>
                  <p className="w-[43%] h-[50%] overflow-auto text-xl mb-[5%] ">
                    {data.zh_content}
                  </p>
                  <Img
                    src={
                      isEnterHoverStart ? "../media/inH.png" : "../media/in.png"
                    }
                    className="flex w-[20%] mb-20 cursor-pointer"
                    alt="arrow3 icon"
                    onClick={goVr}
                    onMouseEnter={() =>
                      (uiState[event].isEnterHoverStart = true)
                    }
                    onMouseLeave={() =>
                      (uiState[event].isEnterHoverStart = false)
                    }
                  />
                </div>
              </div>
            </motion.div>

            {/* copyright  */}

            <motion.div
              key="copyRight"
              initial={{ opacity: 0, y: "97%" }}
              animate={{ opacity: 1 }}
              // animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              onClick={() => (uiState[event].isLastAnimationOpen = true)}
              onAnimationComplete={() =>
                (uiState[event].isLastAnimationOpen = false)
              }
              className={`flex justify-center absolute top-[92%] right-0 w-[63.5%] h-full  box-border`}>
              <div className="w-full h-full absolute left-0 top-[2%] z-50">
                <div className="flex items-center justify-center space-x-10">
                  <Img src="../media/thxname1.png" className="object-contain" />
                  <Img src="../media/thxname2.png" />
                </div>
              </div>
              {/* </div> */}
            </motion.div>
          </div>
        </motion.div>
      </AnimatePresence>
    </>
  );
}
